import axios from '../utils/thirdRequest'
const baseRequest = (url, methodType, params, options) => {
  axios.defaults.withCredentials = true

  let request = {
    url: url,
    method: methodType,
  }
  if (options != null) {
    for (let key in options) {
      request[key] = options[key]
    }
  }

  if (params != null) {
    var formData = null
    for (let key in params) {
      //如果有文件，则使用FormData
      if (params[key] instanceof File) {
        formData = new FormData()
        break
      }
    }
    if (formData == null) {
      //非文件上传操作使用URLSearchParams
      formData = new URLSearchParams()
    }
    for (let key in params) {
      formData.append(key, params[key])
    }
    //如果是post请求，以formdata的形式传递
    if (methodType.toUpperCase() == 'GET') request.params = formData
    else request.data = formData
  }
  return axios(request)
}

const downLoadFile = (url, methodType, params, options) => {
  const requestConfig = {
    url,
    method: methodType.toUpperCase(),
    responseType: 'arraybuffer',
    withCredentials: true,
    ...options // 允许覆盖默认配置
  };

  // 2. 处理参数（区分 GET/POST）
  if (Object.keys(params).length > 0) {
    const hasFile = Object.values(params).some(val => val instanceof File);

    if (hasFile) {
      // 文件上传用 FormData
      const formData = new FormData();
      Object.entries(params).forEach(([key, val]) => formData.append(key, val));
      requestConfig.data = formData;
    } else if (methodType.toUpperCase() === 'GET') {
      // GET 请求参数放在 URL 查询字符串
      requestConfig.params = params;
    } else {
      // POST/PUT 等非文件请求，默认用 JSON
      requestConfig.data = params;
    }
  }

  // 3. 发送请求
  return axios(requestConfig);
}

export { baseRequest, downLoadFile }
